// extracted by mini-css-extract-plugin
module.exports = {"authButton":"ThirdPartyAuthButtons_authButton___ScqZ","divider":"ThirdPartyAuthButtons_divider__Q3vEc"};